@import "src/globals/grid.scss", "src/globals/common.scss", "src/globals/theme.scss", "src/globals/font.scss";

:host {
  display: block;
  width: 100%;
  background-color: $secondaryBackgroundColor;
  border: 1px solid $borderColor;
  border-radius: $borderRadius;
  box-shadow: 12px 12px 2px 1px $borderColor;
  padding: $componentPadding;
  box-sizing: border-box;
  position: sticky;
  font-feature-settings: normal !important;

  .section {
    &--margin {
      margin-top: 20px;
    }
  }

  footer {
    min-height: 30px;
    margin-top: 10px;
    padding: 0 10px;
    background-image: url("https://storage.googleapis.com/carbon-calculator-widget/assets/powered-by.png");
    background-repeat: no-repeat;
    background-position: center right;
    background-size: contain;

    &.logo-only {
      background-image: url("https://storage.googleapis.com/carbon-calculator-widget/assets/pace-logo.png");
    }
  }
}
